import React from 'react';

function ArticlePage() {
  return (
    <div className="min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-slate-800/50 backdrop-blur-sm rounded-2xl shadow-2xl shadow-blue-900/30 p-8 md:p-12 border border-blue-700/30">
          <header className="mb-10 pb-8 border-b-4 border-gradient-to-r from-cyan-500 to-blue-500">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
              <span className="bg-gradient-to-r from-cyan-300 via-blue-300 to-cyan-400 bg-clip-text text-transparent">
                Casino med Hurtig Udbetaling
              </span>
            </h1>
            <p className="text-sm text-blue-400">
              Opdateret: November 2025 | Læsetid: 8 minutter
            </p>
          </header>

          <div className="mb-12 p-8 bg-gradient-to-r from-blue-900/40 to-cyan-900/20 rounded-xl border-l-4 border-cyan-500 shadow-lg shadow-cyan-900/20">
            <p className="text-xl text-blue-100 mb-5 leading-relaxed">
              Når du vinder på et online casino, vil du naturligvis have dine gevinster udbetalt 
              så hurtigt som muligt. Et casino med hurtig udbetaling gør det muligt at få adgang 
              til dine penge på få timer, i stedet for at vente i dage.
            </p>
            <p className="text-lg text-blue-200 leading-relaxed">
              I denne guide gennemgår vi alt, hvad du behøver at vide om casinoer med hurtige 
              udbetalinger i Danmark.
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-8 pb-3 border-b-2 border-blue-700/50 bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">
              Kontobekræftelse for Hurtige Udbetalinger
            </h2>
            <p className="text-lg text-blue-200 mb-6 leading-relaxed">
              Før du kan få din første udbetaling fra et online casino, skal du gennemgå en 
              kontobekræftelsesproces kendt som KYC (Know Your Customer).
            </p>

            <h3 className="text-2xl font-bold text-cyan-300 mb-5 mt-10">
              Nødvendige Dokumenter
            </h3>
            <ul className="space-y-4 ml-4 mb-8">
              <li className="flex items-start gap-3 text-lg text-blue-100 leading-relaxed">
                <span className="text-cyan-400 text-xl">•</span>
                <span><span className="font-bold text-cyan-300">Billedlegitimation:</span> Kørekort, pas eller sundhedskort</span>
              </li>
              <li className="flex items-start gap-3 text-lg text-blue-100 leading-relaxed">
                <span className="text-cyan-400 text-xl">•</span>
                <span><span className="font-bold text-cyan-300">Adressebevis:</span> Forbrugsregning (max 3 måneder)</span>
              </li>
              <li className="flex items-start gap-3 text-lg text-blue-100 leading-relaxed">
                <span className="text-cyan-400 text-xl">•</span>
                <span><span className="font-bold text-cyan-300">Betalingsmetode:</span> Kopi af kort eller e-wallet</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-cyan-300 mb-5 mt-10">
              Tips til Hurtig Verifikation
            </h3>
            <div className="bg-gradient-to-r from-green-900/40 to-emerald-900/20 border-l-4 border-green-500 p-6 rounded-xl shadow-lg shadow-green-900/20">
              <p className="text-lg text-green-100 mb-4 leading-relaxed">
                <span className="font-bold text-green-300">Upload dokumenter straks</span> - Vent ikke til første udbetaling
              </p>
              <p className="text-lg text-green-100 leading-relaxed">
                <span className="font-bold text-green-300">Brug høj kvalitet</span> - Tag billeder i godt lys
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-8 pb-3 border-b-2 border-blue-700/50 bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">
              Hurtigste Betalingsmetoder
            </h2>

            <div className="space-y-6">
              <div className="bg-slate-900/50 border-2 border-blue-700/30 rounded-xl p-6 hover:border-cyan-500/50 hover:shadow-xl hover:shadow-cyan-900/20 transition-all duration-300">
                <h3 className="text-2xl font-bold text-cyan-300 mb-3">E-wallets</h3>
                <p className="inline-block px-4 py-2 bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-sm font-bold rounded-full mb-4 shadow-lg shadow-cyan-500/30">
                  ⚡ 0-24 timer
                </p>
                <p className="text-lg text-blue-200 leading-relaxed">
                  E-wallets som Skrill, Neteller og PayPal er blandt de absolut hurtigste metoder.
                </p>
              </div>

              <div className="bg-gradient-to-r from-amber-900/30 to-yellow-900/20 border-2 border-amber-600/40 rounded-xl p-6 hover:border-amber-500/60 hover:shadow-xl hover:shadow-amber-900/20 transition-all duration-300">
                <h3 className="text-2xl font-bold text-amber-300 mb-3">Kryptovalutaer</h3>
                <p className="inline-block px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white text-sm font-bold rounded-full mb-4 shadow-lg shadow-green-500/30">
                  ⚡⚡ 0-15 minutter
                </p>
                <p className="text-lg text-amber-100 leading-relaxed">
                  På udenlandske casinoer er krypto den hurtigste metode.
                </p>
              </div>

              <div className="bg-slate-900/50 border-2 border-blue-700/30 rounded-xl p-6 hover:border-cyan-500/50 hover:shadow-xl hover:shadow-cyan-900/20 transition-all duration-300">
                <h3 className="text-2xl font-bold text-cyan-300 mb-3">MobilePay</h3>
                <p className="inline-block px-4 py-2 bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-sm font-bold rounded-full mb-4 shadow-lg shadow-cyan-500/30">
                  ⚡ 0-24 timer
                </p>
                <p className="text-lg text-blue-200 leading-relaxed">
                  Populær på danske casinoer med direkte bankoverførsel.
                </p>
              </div>
            </div>
          </section>

          <section className="bg-gradient-to-r from-slate-900/60 to-blue-900/40 rounded-xl p-8 border-l-4 border-cyan-500 shadow-xl shadow-cyan-900/10">
            <h2 className="text-3xl font-bold mb-5 bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">
              Konklusion
            </h2>
            <p className="text-lg text-blue-100 leading-relaxed">
              At vælge et casino med hurtig udbetaling handler om at finde en platform der 
              kombinerer hurtige transaktioner med sikkerhed og god kundeservice.
            </p>
          </section>
        </article>
      </div>
    </div>
  );
}

export default ArticlePage;